module.exports = __webpack_public_path__ + "img/icon-attributed-credits.a59e4a98.svg";